import isPromise from './isPromise';
import isPlainObject from './isPlainObject';

const PENDING = 'PENDING';
const FULFILLED = 'FULFILLED';
const REJECTED = 'REJECTED';

function isAction(action) {
  return isPlainObject(action) && typeof action.type !== 'undefined';
}

export default function promiseMiddleware(store) {
  const { dispatch } = store;

  return next => action => {
    if (typeof action === 'function') return action(store);

    if (!isAction(action) || !isPromise(action.payload) || action.error) {
      return next(action);
    }

    const { type, payload, meta } = action;

    dispatch({ type: `${type}_${PENDING}`, meta });

    return payload.then(
      result => dispatch({ type: `${type}_${FULFILLED}`, payload: result, meta }),
      error => dispatch({ type: `${type}_${REJECTED}`, payload, error,  meta })
    );
  };
};



// WEBPACK FOOTER //
// ./src/store/clientMiddleware.js